<nz-layout>
  <nz-content>
    <app-reusable-table
      title="Past Episodes of Care"
      [isLoading]="isLoading"
      [columns]="[
        'Potential Diagnosis',
        'Activation Date',
        'End Date',
        'Status'
      ]"
      [rowFields]="[
        'potentialDiagnosis',
        'activationDate',
        'endDate',
        'status'
      ]"
      [data]="episodesOfCare"
      [expandComponent]="expandComp"
      [customActions]="customActions"
    />
  </nz-content>
</nz-layout>
